import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BaryColorService {
  static exportColor(property: string, color: string): void {
    if (color) {
      const lhs = BaryColorService.hexToHSL(color);
      document.documentElement.style.setProperty(property, color);
      document.documentElement.style.setProperty(property + '-h', lhs.h);
      document.documentElement.style.setProperty(property + '-l', lhs.l);
      document.documentElement.style.setProperty(property + '-s', lhs.s);
      document.documentElement.style.setProperty(property + '-a', lhs.a);
      if (parseInt(lhs.l, 10) > 80) {
        document.documentElement.style.setProperty(property + '-background-text', '#000');
      } else {
        document.documentElement.style.setProperty(property + '-background-text', '#fff');
      }
    }
  }

  private static hexToHSL(hex: string): { s: string; h: string; l: string; a: string } {
    const ex = /^#([\da-f]{3}){1,2}$/i;
    if (ex.test(hex)) {
      // convert hex to RGB first
      let r: any = 0,
        g: any = 0,
        b: any = 0;
      if (hex.length === 4) {
        r = '0x' + hex[1] + hex[1];
        g = '0x' + hex[2] + hex[2];
        b = '0x' + hex[3] + hex[3];
      } else if (hex.length === 7) {
        r = '0x' + hex[1] + hex[2];
        g = '0x' + hex[3] + hex[4];
        b = '0x' + hex[5] + hex[6];
      }
      // then to HSL
      r /= 255;
      g /= 255;
      b /= 255;
      const cMin = Math.min(r, g, b);
      const cMax = Math.max(r, g, b);
      const delta = cMax - cMin;
      let h = 0;
      let s = 0;
      let l = 0;

      if (delta === 0) {
        h = 0;
      } else if (cMax === r) {
        h = ((g - b) / delta) % 6;
      } else if (cMax === g) {
        h = (b - r) / delta + 2;
      } else {
        h = (r - g) / delta + 4;
      }

      h = Math.round(h * 60);

      if (h < 0) {
        h += 360;
      }

      l = (cMax + cMin) / 2;
      s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
      s = +(s * 100).toFixed(1);
      l = +(l * 100).toFixed(1);

      return { h: '' + h, s: s + '%', l: l + '%', a: '' + 1 };
    } else {
      console.error('Invalid input color');
      return { h: '', l: '', s: '', a: '' };
    }
  }

  private static shadeColor(property: string, color: string, percent: number): void {
    let R = parseInt(color.substring(1, 3), 16);
    let G = parseInt(color.substring(3, 5), 16);
    let B = parseInt(color.substring(5, 7), 16);

    R = parseInt(String((R * (100 + percent)) / 100), 10);
    G = parseInt(String((G * (100 + percent)) / 100), 10);
    B = parseInt(String((B * (100 + percent)) / 100), 10);

    R = R < 255 ? R : 255;
    G = G < 255 ? G : 255;
    B = B < 255 ? B : 255;

    const RR = R.toString(16).length === 1 ? '0' + R.toString(16) : R.toString(16);
    const GG = G.toString(16).length === 1 ? '0' + G.toString(16) : G.toString(16);
    const BB = B.toString(16).length === 1 ? '0' + B.toString(16) : B.toString(16);

    document.documentElement.style.setProperty(property, '#' + RR + GG + BB);
  }

  private static alphaColor(property: string, color: string, percent: number): void {
    const R = parseInt(color.substring(1, 3), 16);
    const G = parseInt(color.substring(3, 5), 16);
    const B = parseInt(color.substring(5, 7), 16);

    const perc = percent / 100;

    document.documentElement.style.setProperty(property, 'rgba(' + R + ',' + G + ',' + B + ',' + perc + ')');
  }
}
